import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ComponentStore } from "@ngrx/component-store";
import { bl_fi_generic_doc_line_RowClass } from "blg-akaun-ts-lib";
import { ToastrService } from "ngx-toastr";
import { ViewColumnComponent } from "../../view-column.component";
import { SubSink } from "subsink2";
import { Observable } from "rxjs";

export class DiscountElement{
  percentage : number;
  amount : number;
  unit_price_after_disc_exc_tax: number;
  unit_price_after_disc_inc_tax: number;
}
@Component({
    selector: 'app-util-multi-level-discount',
    templateUrl: './multi-level-discount.component.html',
    styleUrls: ['./multi-level-discount.component.css'],
    providers: [ComponentStore]
})
export class MultiLevelDiscountComponent extends ViewColumnComponent  {
  @Output() updateMainPrice = new EventEmitter<number>();
  @Output() resetMainPrice = new EventEmitter();
  @Input() unitPriceAfterDisc;
  @Input() line$ : Observable<bl_fi_generic_doc_line_RowClass>;

  defaultColDef = {
    autoHeight:true,
    wrapText: true,
    filter: 'agTextColumnFilter',
    floatingFilterComponentParams: {suppressFilterButton: false},
    sortable: true,
    resizable: true,
    suppressCsvExport: true
  };
  qty = 1;
  unitPrice = 0;
  //unitPriceAfterDisc = 0;
  columnsDefs = [
    {
        headerName: "Unit Discount %",
        field: "percentage",
        minWidth: 200,
        flex: 1,
        suppressSizeToFit: true,
        type: 'numericColumn',
        cellStyle: { textAlign: "right" },
        valueFormatter: this.showPercentage,
    },
    {
      headerName: "Unit Discount Amount",
      field: "amount",
      minWidth: 200,
      flex: 1,
      type: 'numericColumn',
      suppressSizeToFit: true,
      cellStyle: { textAlign: "right" },
    },
    {
        headerName: "Unit Price After Disc",
        field: "unit_price_after_disc_exc_tax",
        minWidth: 200,
        flex: 1,
        suppressSizeToFit: true,
        cellStyle: { textAlign: "right" },
        type: 'numericColumn',
        valueFormatter: params => params.value?.toFixed(2),
      },
  ];
  rowData = [];
  totalRecords = 0;
  sqlGuids: string[] = null;
  limit = 100;
  gridApi;
  protected readonly index = 0;
  private subs = new SubSink();
  public form: FormGroup;

  constructor(
    private toastr: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    this.form = new FormGroup({
        discPercentage: new FormControl('0.00'),
        discAmt: new FormControl('0.00'),
    })
    if (this.line$) {
      this.subs.sink = this.line$.subscribe({
        next: (line: any) => {
          if (line?.multi_level_disc_json) {
            this.rowData = line?.multi_level_disc_json?.discount;
          }
        },
      });
    }
  }


  showPercentage(params) {
    return parseFloat(params.value).toFixed(2) + "%";
  }

  onAddPercentage(){
    const amt = this.unitPriceAfterDisc ;
    if(amt && amt!=0){
      const el = new DiscountElement();
      el.percentage =  this.form.value.discPercentage;
      el.amount =  Number(((el.percentage/100) * amt).toFixed(2));
      el.unit_price_after_disc_exc_tax = (amt*(1-el.percentage/100) );
      el.unit_price_after_disc_inc_tax = (amt*(1-el.percentage/100) );
      this.unitPriceAfterDisc =  this.unitPriceAfterDisc  - (el.amount);
      this.createData(el);
      this.updateMainPrice.emit(this.unitPriceAfterDisc);
      this.form.controls['discPercentage'].setValue('0.00');
    }else{
      this.toastr.warning(
        'No discount can be applied to this item',
        'Warning',
        {
          tapToDismiss: true,
          progressBar: true,
          timeOut: 1300
        }
      );
    }
  }

  onAddAmount(){
    const amt = this.unitPriceAfterDisc;
    if(amt && amt!=0){
      const el = new DiscountElement();
      el.percentage =100 - (((amt-this.form.value.discAmt) / amt) * 100);
      el.percentage = <any> parseFloat(el.percentage.toString()).toFixed(2)
      el.amount = this.form.value.discAmt;
      el.unit_price_after_disc_exc_tax = (amt-el.amount );
      el.unit_price_after_disc_inc_tax = (amt-el.amount );
      this.unitPriceAfterDisc =  this.unitPriceAfterDisc  - (el.amount);
      this.createData(el);
      this.updateMainPrice.emit(this.unitPriceAfterDisc);
      this.form.controls['discAmt'].setValue('0.00');
    }else{
      this.toastr.warning(
        'No more discount can be applied to this item',
        'Warning',
        {
          tapToDismiss: true,
          progressBar: true,
          timeOut: 1300
        }
      );
    }

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
    this.gridApi.sizeColumnsToFit();
  }

  createData(el: DiscountElement) {
    this.rowData.push(el)
    this.gridApi.setRowData(this.rowData);
  }

  onRemove(){
    this.rowData = [];
    this.gridApi.setRowData(this.rowData);
    this.resetMainPrice.emit();
    this.form.controls['discPercentage'].setValue('0.00');
    this.form.controls['discAmt'].setValue('0.00');
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
